import { render, staticRenderFns } from "./dealer.vue?vue&type=template&id=113b1e5c&scoped=true&"
import script from "./dealer.vue?vue&type=script&lang=js&"
export * from "./dealer.vue?vue&type=script&lang=js&"
import style0 from "./dealer.vue?vue&type=style&index=0&id=113b1e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113b1e5c",
  null
  
)

export default component.exports